import { render, staticRenderFns } from "./SupplierInvoiceDetails.vue?vue&type=template&id=41e95782&scoped=true"
import script from "./SupplierInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./SupplierInvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./SupplierInvoiceDetails.vue?vue&type=style&index=0&id=41e95782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e95782",
  null
  
)

export default component.exports